import { Tooltip as StyledTooltip } from './Tooltip.styled';
import { Props } from './types';

export const Tooltip = ({ ...props }: Props) => <StyledTooltip {...props} />;

export default Tooltip;
